import { Injectable } from '@angular/core';
import { Observable, of, delay } from 'rxjs';
import { UserService } from './user.service';
import { UserListItem, UserSearchParam } from '../../interfaces/user/user-type.interface';
import { PageResponse } from '../../../../core/interfaces/page-response.interface';

@Injectable({
    providedIn: 'root'
})
export class UserMockService extends UserService {
    private mockUsers: UserListItem[] = [
        { uniqueId: '1', fullName: 'John Doe', email: 'john@example.com', phoneNumber: '+1 (555) 123-4567', role: 'ADMIN', isActive: true, createdAt: '2024-01-01', lastLogin: '2024-03-12', createdBy: 'System' },
        { uniqueId: '2', fullName: 'Jane Smith', email: 'jane@example.com', phoneNumber: '+1 (555) 987-6543', role: 'SUPPORT_USER', isActive: true, createdAt: '2024-01-05', lastLogin: '2024-03-13', createdBy: 'System' },
        { uniqueId: '3', fullName: 'Mike Ross', email: 'mike@example.com', phoneNumber: '+1 (555) 234-5678', role: 'SUPPORT_USER', isActive: true, createdAt: '2024-02-10', createdBy: 'System' },
        { uniqueId: '4', fullName: 'Harvey Specter', email: 'harvey@example.com', phoneNumber: '+1 (555) 876-5432', role: 'ADMIN', isActive: true, createdAt: '2024-01-15', lastLogin: '2024-03-10', createdBy: 'System' },
        { uniqueId: '5', fullName: 'Donna Paulsen', email: 'donna@example.com', phoneNumber: '+1 (555) 345-6789', role: 'SUPPORT_USER', isActive: false, createdAt: '2024-02-01', createdBy: 'System' },
    ];

    constructor() {
        super();
    }

    override findAll(searchParam: UserSearchParam): Observable<PageResponse<UserListItem>> {
        let filtered = [...this.mockUsers];
        if (searchParam.searchTerm) {
            const term = searchParam.searchTerm.toLowerCase();
            filtered = filtered.filter(u =>
                u.fullName.toLowerCase().includes(term) ||
                u.email.toLowerCase().includes(term)
            );
        }

        const response: PageResponse<UserListItem> = {
            content: filtered,
            page: {
                number: searchParam.page,
                size: searchParam.size,
                totalElements: filtered.length,
                totalPages: 1
            }
        };

        return of(response).pipe(delay(500));
    }

    override find(id: string): Observable<UserListItem> {
        const user = this.mockUsers.find(u => u.uniqueId === id);
        return of(user!).pipe(delay(300));
    }

    override create(data: any): Observable<any> {
        const newUser = {
            ...data,
            uniqueId: Math.random().toString(36).substr(2, 9),
            createdAt: new Date().toISOString()
        };
        this.mockUsers.push(newUser);
        return of(newUser).pipe(delay(500));
    }

    override update(id: string, data: any): Observable<any> {
        const index = this.mockUsers.findIndex(u => u.uniqueId === id);
        if (index > -1) {
            this.mockUsers[index] = { ...this.mockUsers[index], ...data };
            return of(this.mockUsers[index]).pipe(delay(500));
        }
        throw new Error('User not found');
    }

    override delete(id: string): Observable<void> {
        this.mockUsers = this.mockUsers.filter(u => u.uniqueId !== id);
        return of(void 0).pipe(delay(500));
    }

    override updateStatus(id: string, status: boolean): Observable<void> {
        const index = this.mockUsers.findIndex(u => u.uniqueId === id);
        if (index > -1) {
            this.mockUsers[index].isActive = status;
        }
        return of(void 0).pipe(delay(500));
    }

    override updatePassword(uniqueId: string, password: string): Observable<void> {
        return of(void 0).pipe(delay(800));
    }
}
